import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

export default function Loader({message, fullScreen=false, sx={}}) {
    let styles = {};
    if (fullScreen) {
        styles.minHeight = 'calc(100vh - 100px)';
    }
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f5f5f5',
                ...styles,
                ...sx
            }}
        >
            <CircularProgress />
            <Typography variant="h6" sx={{ mt: 2 }}>
                {message || 'Loading, please wait...'}
            </Typography>
        </Box>
    );
}